
import utils from '../utils'

const ZJMenu = function(menu) {
    this.init(menu);
};

const pt = ZJMenu.prototype;

pt.init = function(menu) {
    this.currentNavMenu = null;
    this.currentMenu = null;
    if (menu) {
        this.setMenu(menu);
    }
};

function getPath(menu) {
    let codes = [];
    let parent = menu;
    let cnt = 0;
    while (parent) {
      codes.push(parent.MenuCode || parent.MenuId);
      parent = parent.$parent;
      cnt++;
      if (parent && cnt >= 10) {
        parent = null;
        throw new Error('菜单的递归等级过深');
      }
    }
  
    codes = codes.reverse();
  
    return '/' + codes.join('/');
}

function inject(menu, parent) {
    Object.defineProperty(menu, "$parent", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: parent
    });
    let routePath = getPath(menu);
    Object.defineProperty(menu, "$routePath", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: routePath
    });
    let routeQuery = null;
    let routeHash = null;
    if (menu.MenuUrl) {
        let url = menu.MenuUrl;
        let index = url.indexOf('?');
        if (index == -1) {
            index = url.indexOf('#');
        }
        if (index != -1) {
            routePath += url.substr(index);
        }

        index = url.indexOf('#');
        if (index != -1) {
            routeHash = url.substr(index + 1);
            url = url.substr(0, index);
        }
        index = url.indexOf('?');
        if (index != -1) {
            let query = url.substr(index + 1);
            if (query) {
                let arr = query.split('&');
                let q = {};
                for (let i = 0;i < arr.length; i++) {
                    let sub = arr[i].split('=');
                    q[sub[0]] = decodeURIComponent(sub[1]);
                }
                routeQuery = q;
            }
        }
        
    }
    Object.defineProperty(menu, "$routeQuery", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: routeQuery
    });
    Object.defineProperty(menu, "$routeHash", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: routeHash
    });
    Object.defineProperty(menu, "$routeFullPath", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: routePath
    });
}

pt.setMenu = function(menu, config) {
    this.$config = config;
    this.extend(menu);
    inject(this, null);
    this.each((m,i,p)=>{
        inject(m, p);
    });
    let promises = [];
    this.each(m=>{
        promises.push(utils.waitAll([
            config.resolveRef(m.MenuUrl).then(d=>m.MenuUrl=d),
            config.resolveRef(m.MenuImg).then(d=>m.MenuImg=d)
        ]));
    });
    return utils.waitAll(promises);
};

function _each(root, fn, lv) {
    lv = lv || 0;
    lv++;
    utils.each(root.MenuInfos || [], (m,i)=>{
        let r = fn.apply(this, [m,i,root,lv]);
        if (r === false) {
            return false;
        }
        if (m.MenuInfos) {
            _each(m, fn, lv + 1);
        }
    });
}

pt.each = function(fn) {
    _each(this, fn, 0);
    return this;
};

function _resolveRef(root, config) {
    return new Promise(function (resolve, reject) {
        const arr = [];
        arr.push(()=>config.resolveRef(root.MenuCode));
        arr.push(()=>config.resolveRef(root.MenuUrl));
        arr.push(()=>config.resolveRef(root.MenuImg));
        utils.each(root.MenuInfos || [], m=>{
            arr.push(()=>_resolveRef(m, config));
        });
        utils.waitAll(arr)
        .then(r=>{
            let [menuCode, menuUrl, menuImg] = r;
            root.MenuCode = menuCode;
            root.MenuUrl = menuUrl;
            root.MenuImg = menuImg;
            resolve(root);
        },
        e=>reject(e));
    });
}

// 解析配置引用
pt.resolveRef = function(config) {
    return _resolveRef(this, config);
};

pt.extend = function() {
    return utils.extend.apply(this, [this, ...arguments])
};

// 根据 menuId 在孩子菜单中查找
pt.findChildMenu = function (menuId, root) {
    let find;
    if (typeof root === 'undefined') {
        root = this;
    }
    utils.each(root.MenuInfos||[],
        x=>{
            const isActive = x.MenuId == menuId;
            if (isActive) {
                find = x;
                return false;
            }
        });
    return find;
};

pt.findNavMenu = function (menuId) {
    return this.findChildMenu(menuId, this);
};

//根据 $routePath 查找
pt.findMenuByRoutePath = function (routePath, root, sameFunc) {
    let find;
    if (typeof(root) === 'function') {
        sameFunc = root;
        root = undefined;
    }
    if (typeof(sameFunc) !== 'function') {
        sameFunc = function(m,p) {
            if (p && p[p.length - 1] == '/') p = p.substr(0, p.length - 1);
            return m && p && m.$routePath && m.$routePath.toLowerCase() == p.toLowerCase();
        };
    }
    if (!root) {
        root = this;
    }
    if (sameFunc(root, routePath)) {
        return root;
    }
    utils.each(root.MenuInfos||[],
        x=>{
            find = this.findMenuByRoutePath(routePath, x);
            if (find) {
                return false;
            }
        });
    return find;
};

//根据 $routeFullPath 查找
pt.findMenuByRouteFullPath = function (routePath, root, sameFunc) {
    let find;
    if (typeof(root) === 'function') {
        sameFunc = root;
        root = undefined;
    }
    if (typeof(sameFunc) !== 'function') {
        sameFunc = function(m,p) {
            if (p && p[p.length - 1] == '/') p = p.substr(0, p.length - 1);
            return m && p && m.$routeFullPath && m.$routeFullPath == p;
        };
    }
    if (!root) {
        root = this;
    }
    if (sameFunc(root, routePath)) {
        return root;
    }
    utils.each(root.MenuInfos||[],
        x=>{
            find = this.findMenuByRouteFullPath(routePath, x);
            if (find) {
                return false;
            }
        });
    return find;
};

pt.findMenuByMenuId = function (menuId, root) {
    let find;
    if (typeof root === 'undefined') {
        root = this;
    }
    if (root.MenuId == menuId) {
        return root;
    }
    utils.each(root.MenuInfos||[],
        x=>{
            find = this.findMenuByMenuId(menuId, x);
            if (find) {
                return false;
            }
        });
    return find;
};

pt.findMenuByMenuUrl = function (menuUrl, root) {
    let find;
    if (typeof root === 'undefined') {
        root = this;
    }
    if (!menuUrl) {
        return root;
    }
    if (root.MenuUrl && root.MenuUrl.toLowerCase() == menuUrl.toLowerCase()) {
        return root;
    }
    utils.each(root.MenuInfos||[],
        x=>{
            find = this.findMenuByMenuUrl(menuUrl, x);
            if (find) {
                return false;
            }
        });
    return find;
};

pt.menuUrlToRoutePath = function(url) {
    let index = url.lastIndexOf('?');
    if (index == -1)
        index = url.lastIndexOf('#');
    let query = '';
    if (index != -1) {
        query = url.substr(index);
        url = url.substr(0, index);
    }
    var vars = utils.parseUrl(url);
    return '/plugin/' + vars.host + vars.path + query;
};

// 根据路径获取菜单实例
pt.findMenu = function (menuPath, root) {
    if (typeof root === 'undefined') {
        root = this;
    }
    for (let i = 0;i < menuPath.length; i++) {
        let find = this.findChildMenu(menuPath[i], root);
        if (!find) return undefined;
        root = find;
    }
    return root;
};

// 选中一个导航菜单
pt.selectNavMenu = function (menu) {
    let root = this;
    let find = null;
    utils.each(root.MenuInfos||[],
        x=>{
            const isActive = x.MenuId == menu.MenuId;
            x.isActive = isActive;
            //Vue.set(x, 'isActive', isActive);
            if (isActive) {
                find = x;
            }
        });
    this.currentNavMenu = find;
};

// 选中一个侧边菜单
pt.selectMenu = function (menu) {
    this.currentMenu = menu;
};

// 是否是导航菜单
pt.isNavMenu = function(menu) {
    return menu && menu.$parent === this;
};

// 查找当前菜单的导航菜单
pt.findNavMenu = function(menu) {
    if (this.isNavMenu(menu)) {
        return menu;
    }
    let m = menu.$parent;
    while (m && !this.isNavMenu(m)) {
        m = m.$parent;
    }
    return m;
}

pt.printTree = function() {
    this.each((m,i,root,lv)=>{
        let s = '';
        for(let i = 0; i < lv; i++) {
            s += ' ';
        }
        s += '<a' +
        ' href="' + m.$routePath + '"' +
        ' menu-url="'+m.MenuUrl+'"' +
        ' menu-icon="'+m.MenuImg+'"' +
        '>' + m.MenuName + '</a>';
        console.log(s);
    });
};

let global = window || {};
ZJMenu.install = function(Vue) {
    // 切换为响应式扩展
    pt.extend = function() {
        return Vue.reactiveExtend.apply(this, [this, ...arguments])
    }
  
    ZJMenu.current = new ZJMenu();
    global.$menu = global.ZJApp.menu = ZJMenu.current;
    
    // 混入用户
    Vue.mixin({
        data() {
            return {
                menu: ZJMenu.current
            };
        }
    });
}

export default ZJMenu;